import { default as FEATURES } from '../../../common/feature-enum';
import { NAVIGATION, routeToClaim } from '../../../common/navigation-enums';

const MENU_NAME = 'topbar';
const LOGO_OPTIONS = ['icon', 'full', 'none'];

const MENU_PAGE_BY_STATE = {
    [FEATURES.DASHBOARD]: NAVIGATION.PropertyList,
    [FEATURES.ACCOUNT_HISTORY]: NAVIGATION.AccountHistory,
    [FEATURES.DOCUMENTS]: NAVIGATION.BuildingDocuments,
    [FEATURES.COMPLIANCE]: NAVIGATION.Compliance,
    [FEATURES.FINANCIAL_SUMMARY]: NAVIGATION.FinancialPack,
    [FEATURES.PAYMENTS]: NAVIGATION.PaymentApprovals,
    [FEATURES.PAYMENT_AUTHORISATION]: NAVIGATION.PaymentAuthorisation,
    [FEATURES.PERSONAL_DOCUMENTS]: NAVIGATION.PersonalDocuments,
    [FEATURES.TENANT]: NAVIGATION.ManageTents,
    [FEATURES.UTILITY]: NAVIGATION.Utility,
    [FEATURES.DOCUMENTS_APPROVAL]: NAVIGATION.DocumentsApproval,
    [FEATURES.SHOW_FIND_A_CONTRACTOR]: NAVIGATION.ShowFindAContractor,
    [FEATURES.AUDITORS_DASHBOARD]: NAVIGATION.AuditorsDashboard
};

class MobileTopBar {
    constructor($state, $timeout, $document, $rootScope, $templateCache, AuthorizationService, LocalStorageService) {
        this.$state = $state;
        this.$timeout = $timeout;
        this.$document = $document;
        this.$rootScope = $rootScope;
        this.$templateCache = $templateCache;
        this.AuthorizationService = AuthorizationService;
        this.LocalStorageService = LocalStorageService;

        this.scope = true;
        this.template = this.$templateCache.get('nav-bar/top/mobile-top-bar-tmpl.html');
        this.link = this.MobileTopBarLink.bind(this);
    }

    MobileTopBarLink(scope, element, attrs) {
        scope.openPanel = null;
        scope.nav = { scope: null };

        scope.logo = 'icon';
        scope.showAvatar = true;

        attrs.$observe('logo', (value) => {
            scope.logo = LOGO_OPTIONS.indexOf(value) > -1 ? value : 'icon';
        });
        attrs.$observe('showAvatar', (value) => {
            scope.showAvatar = value !== 'false';
        });

        scope.propertyName = () => {
            const user = scope.MainVM && scope.MainVM.user;
            const selectedRef = ((scope.MainVM && scope.MainVM.selectedBuildingRef) || '').toUpperCase();
            const building = ((user && user.BuildingProfiles) || [])
                .find(b => (b.SchemeReference || '').toUpperCase() === selectedRef);
            return building ? building.SchemeName : '';
        };

        scope.hasProperties = () => {
            const user = scope.MainVM && scope.MainVM.user;
            return !!(user && user.BuildingProfiles && user.BuildingProfiles.length);
        };

        scope.noPropertyText = () => scope.hasProperties() ? 'Select a property' : 'No property linked';

        scope.initials = () => {
            const fullName = (scope.MainVM && scope.MainVM.user && scope.MainVM.user.FullName) || '';
            const names = fullName.trim().split(/\s+/).filter(Boolean);
            if (names.length === 0) {
                return '';
            }
            const last = names.length > 1 ? names[names.length - 1].charAt(0) : '';
            return (names[0].charAt(0) + last).toUpperCase();
        };

        scope.togglePanel = (panel, section) => {
            if (scope.openPanel === panel) {
                scope.closeMenu();
            } else if (panel === 'menu') {
                scope.openMenu(section);
            } else {
                scope.closeMenu();
                scope.openPanel = panel;
            }
        };

        const PICKERS = {
            property: { toggle: 'buildings-top-nav .mobile-picker-toggle', isOpen: 'isOpen' },
            page: { toggle: 'navigation .mobile-picker-toggle', isOpen: 'isMenuOpen' }
        };
        scope.openMenu = (section) => {
            scope.openPanel = 'menu';
            const picker = PICKERS[section];
            if (!picker) {
                return;
            }
            this.$timeout(() => {
                const toggle = element[0].querySelector(picker.toggle);
                if (!toggle) {
                    return;
                }
                if (!angular.element(toggle).scope()[picker.isOpen]) {
                    toggle.click();
                }
                toggle.focus({ preventScroll: true });
            }, 0, false);
        };

        const offOpen = this.$rootScope.$on('topbar-open', (event, section) => {
            this.$document[0].defaultView.scrollTo(0, 0);
            scope.openMenu(section);
        });
        scope.$on('$destroy', offOpen);

        scope.closeMenu = () => {
            scope.openPanel = null;
            this.$rootScope.$broadcast('mobile-menu-opened', MENU_NAME);
        };

        const closeIfOpen = () => {
            if (scope.openPanel) {
                scope.closeMenu();
            }
        };
        scope.$on('selected-building-changed', closeIfOpen);
        scope.$on('navigate-changed', closeIfOpen);
        scope.$watch(() => this.$state.current.name, closeIfOpen);

        scope.$watch(() => this._fallbackRoute(scope.MainVM), (route) => {
            if (route) {
                this.$state.go(route, {}, { location: 'replace' });
            }
        });

        const onKeydown = (evt) => {
            if (scope.openPanel && (evt.key === 'Escape' || evt.key === 'Esc')) {
                const trigger = scope.openPanel === 'account' ? '.topbar-avatar' : '.topbar-context';
                scope.$apply(scope.closeMenu);
                const button = element[0].querySelector(trigger);
                if (button) {
                    button.focus();
                }
            }
        };
        this.$document.on('keydown', onKeydown);
        scope.$on('$destroy', () => this.$document.off('keydown', onKeydown));
    }

    _fallbackRoute(mainVm) {
        if (!mainVm || !mainVm.isMobile || !mainVm.user || !mainVm.selectedBuildingRef) {
            return null;
        }

        const page = MENU_PAGE_BY_STATE[this.$state.current.name];
        if (!page) {
            return null;
        }

        const features = this.LocalStorageService.retrieve('buildingsFeatures');
        if (!features || !features[String(mainVm.selectedBuildingRef).toUpperCase()]) {
            return null;
        }

        if (mainVm.shouldBeEnabled(routeToClaim(page).description)) {
            return null;
        }

        const route = this.AuthorizationService.unProtectedRoute;
        if (!route || route === this.$state.current.name || !MENU_PAGE_BY_STATE[route]
            || !mainVm.shouldBeEnabled(routeToClaim(MENU_PAGE_BY_STATE[route]).description)) {
            return null;
        }
        return route;
    }
}

export default /* @ngInject */ ($state, $timeout, $document, $rootScope, $templateCache, AuthorizationService, LocalStorageService) =>
    new MobileTopBar($state, $timeout, $document, $rootScope, $templateCache, AuthorizationService, LocalStorageService);
